export function isBrowser(browser: "Firefox") {
  return navigator.userAgent.search(browser) > -1;
}
